"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const _1 = require("./../");
const number_1 = require("./utils/number");
exports.DatagridPagination = (props) => {
    const { limitOptions, limit, skip, total } = props;
    return (React.createElement("div", { className: "bkn-datagrid-pagination" }, !total ? (React.createElement("span", { className: "text-uppercase hidden-xs-down" }, "Results not found")) : ([
        React.createElement("span", { key: 0, className: "pagination-rows-select" }, "Rows per page \u00A0"),
        React.createElement("div", { key: 1, className: "pagination-rows-select" },
            React.createElement("select", { className: "form-control-sm custom-select", value: limit, onChange: handleChangeLimit(props) }, limitOptions.map(o => (React.createElement("option", { key: o, value: o }, o))))),
        React.createElement("span", { key: 2, style: { marginRight: '0.5rem' } },
            number_1.numberWithCommas(skip + 1),
            " - ",
            number_1.numberWithCommas(pageLimit(limit, skip, total)),
            "\u00A0of\u00A0",
            React.createElement("span", null, number_1.numberWithCommas(total))),
        React.createElement("button", { key: 3, className: "btn btn-link btn-page-nav", type: "button", style: { marginRight: '0.5rem' }, onClick: handleChangeSkip(props, 'prev'), disabled: (skip - limit) < 0 },
            React.createElement(_1.Icon, { name: "chevron_left" })),
        React.createElement("button", { key: 4, className: "btn btn-link btn-page-nav", type: "button", onClick: handleChangeSkip(props, 'next'), disabled: (skip + limit + 1) > total },
            React.createElement(_1.Icon, { name: "chevron_right" })),
    ])));
};
exports.DatagridPagination.displayName = 'DatagridPagination';
const handleChangeLimit = (props) => (e) => {
    props.onChangeLimit(parseInt(e.target.value, 10));
};
const handleChangeSkip = (props, direction) => {
    return (e) => {
        const { limit, skip } = props;
        const updatedSkip = direction === 'next'
            ? skip + limit
            : skip - limit;
        props.onChangeSkip(updatedSkip);
    };
};
const pageLimit = (limit, skip, total) => {
    if ((skip + limit) > total) {
        return total;
    }
    return limit + skip;
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Datagrid/DatagridPagination.tsx
// module id = 107
// module chunks = 0